import { Box, Button, Container, Heading, VStack, useToast, Text } from '@chakra-ui/react';
import { useGoogleLogin } from '@react-oauth/google';
import { handleGoogleLogin } from '../utils/googleLogin';
import { FaGoogle } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export const Login = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  // Clear any existing auth data when the login page loads
  useEffect(() => {
    localStorage.clear();
  }, []);

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        const userProfile = await handleGoogleLogin(response.access_token);
        if (userProfile) {
          // Verify the profile has required fields
          if (!userProfile.googleId || !userProfile.email) {
            throw new Error('Invalid user profile data');
          }

          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('access_token', response.access_token);
          localStorage.setItem('user_profile', JSON.stringify(userProfile));
          
          // Trigger storage event for other tabs/windows
          window.dispatchEvent(new Event('storage'));
          
          // Get the intended destination from the location state, or default to home
          const from = (location.state as any)?.from?.pathname || '/';
          navigate(from, { replace: true });
        }
      } catch (error) {
        console.error('Login error:', error);
        localStorage.clear();
        toast({
          title: 'Login Failed',
          description: error instanceof Error ? error.message : 'Failed to log in',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    },
    onError: (error) => {
      console.error('Google Login Error:', error);
      localStorage.clear();
      toast({
        title: 'Login Failed',
        description: 'Failed to log in with Google',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    },
    flow: 'implicit',
    scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email'
  });

  return (
    <Container maxW="container.sm" py={20}>
      <VStack spacing={8}>
        <Heading as="h1" size="xl">
          Welcome to <span style={{ color: '#3182CE' }}>PodSight</span>
        </Heading>
        <Box w="full" maxW="md" p={8} borderWidth={1} borderRadius="lg" boxShadow="lg">
          <VStack spacing={6}>
            <Heading as="h2" size="md">
              Sign in to continue
            </Heading>
            <Text textAlign="center" color="gray.600">
              Access your personalized podcast insights and recommendations
            </Text>
            <Button
              w="full"
              size="lg"
              colorScheme="blue"
              leftIcon={<FaGoogle />}
              onClick={() => login()}
            >
              Sign in with Google
            </Button>
          </VStack>
        </Box>
      </VStack>
    </Container>
  );
}; 